export class NostoCard extends window.BAO.CustomElement() {
  constructor () {
    super()
    if (!this.sectionId) return
    this.initialise()
  }

  async initialise () {
    if (!this.allowEmptyUrl && !this.url) return
    this.isBusy = true

    const storedHtml = window.sessionStorage.getItem(this.cacheKey)
    const html =
      this.cacheKey && storedHtml
        ? storedHtml
        : this.processData(
          await this.sectionRenderer.fetchSingle(
            this.sectionId,
            this.sectionsUrl,
          ),
        )

    if (this.cacheKey) {
      window.sessionStorage.setItem(this.cacheKey, html)
    }

    this.sectionHTML = this.sectionRenderer.getInnerHtml(html)
    this.isBusy = false

    if (
      this.url?.includes('nosto=') &&
      this.classList.contains('prd-Card_Nosto')
    ) {
      const anchors = this.querySelectorAll('a')

      anchors.forEach((anchor) => {
        anchor.setAttribute('href', this.url)
      })

      const buttons = this.querySelectorAll('.prd-Card_Button')
      buttons.forEach((button) => {
        button.setAttribute('data-nosto', this.url)
        button.setAttribute(
          'data-nosto-slot-id',
          this.externalEls.nosto.element.dataset.id,
        )
      })
    }
  }

  processData (html) {
    Object.keys(this.data).forEach((key) => {
      const replacers = [new RegExp(`{{ ${key} }}`, 'g')]
      replacers.forEach((replacer) => {
        html = html.replace(replacer, this.data[key])
      })
    })
    return html
  }

  get sectionId () {
    return this.dataset?.sectionId
  }

  set sectionHTML (html) {
    if (!html) {
      this.remove()
      return
    }
    this.innerHTML = html
  }

  get sectionHTML () {
    return this.innerHTML
  }

  set isBusy (boolean) {
    this.setAttribute('aria-busy', (!!boolean).toString())
  }

  get isBusy () {
    return this.getAttribute('aria-busy') === 'true'
  }

  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }

  get dataEl () {
    return this.els?.data?.element
  }

  get data () {
    return this.dataEl ? JSON.parse(this.dataEl.textContent) : {}
  }

  get url () {
    return this.dataset?.url
  }

  get allowEmptyUrl () {
    return !(this.dataset?.allowEmptyUrl === 'false')
  }

  /**
   * @returns {string} The url, pathname and query parameters
   */
  get sectionsUrl () {
    return this.url || `${window.location.pathname}${window.location.search}`
  }

  get cacheKey () {
    return this.dataset?.cacheKey
  }
}

if (!customElements.get('nosto-card')) {
  customElements.define('nosto-card', NostoCard)
}
